import { render, staticRenderFns } from "./wecaht.vue?vue&type=template&id=0d6cb386&scoped=true"
import script from "./wecaht.vue?vue&type=script&lang=js"
export * from "./wecaht.vue?vue&type=script&lang=js"
import style0 from "./wecaht.vue?vue&type=style&index=0&id=0d6cb386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6cb386",
  null
  
)

export default component.exports